import { ABTestRepository, ABTestRules, ABTestRulesNames } from './ab-test.types.js';

export const AB_TEST_REPOSITORY_KEY = '@remento/ab-test';

export class ABTestLocalRepository<R extends ABTestRules> implements ABTestRepository<R> {
  save(variants: Record<ABTestRulesNames<R>, string>): void {
    localStorage.setItem(AB_TEST_REPOSITORY_KEY, JSON.stringify(variants));
  }

  get(): Record<ABTestRulesNames<R>, string> | null {
    const rawVariants = localStorage.getItem(AB_TEST_REPOSITORY_KEY);
    if (rawVariants != null) {
      return JSON.parse(rawVariants);
    }
    return null;
  }
}
